(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexiluma-deli-waste-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nexiluma-waste-calculator')) {
    class NexilumaWasteCalculator extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('.nx-calculator__form');
        this.steps = [...this.querySelectorAll('.nx-step')];
        this.progress = this.querySelector('.nx-progress span');
        this.results = this.querySelector('[data-results]');
        this.currentStep = 0;
        this.currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
        this.percent = new Intl.NumberFormat('en-US', { maximumFractionDigits: 1 });
        this.bindEvents();
        this.updateCauseTotal();
      }

      bindEvents() {
        const contactForm = this.querySelector('.nx-contact-form');
        if (contactForm) contactForm.addEventListener('submit', (event) => {
          if (!this.querySelector('[data-result-summary]')?.value) {
            event.preventDefault();
            this.form.hidden = false;
            this.results.hidden = true;
            this.showStep(0);
            window.alert('Please calculate your results before requesting a review.');
          }
        });
        this.querySelectorAll('[data-next]').forEach((button) => button.addEventListener('click', () => this.next()));
        this.querySelectorAll('[data-back]').forEach((button) => button.addEventListener('click', () => this.back()));
        this.querySelectorAll('.nx-cause input').forEach((input) => input.addEventListener('input', () => this.updateCauseTotal()));
        this.querySelector('[name="reduction_target"]').addEventListener('input', (event) => {
          this.querySelector('[data-target-output]').textContent = `${event.target.value}%`;
        });
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.calculate();
        });
        this.querySelector('[data-restart]').addEventListener('click', () => this.restart());
        this.querySelector('[data-print]').addEventListener('click', () => window.print());
      }

      number(name) {
        return Math.max(0, Number.parseFloat(this.form.elements[name]?.value) || 0);
      }

      validateStep() {
        const required = [...this.steps[this.currentStep].querySelectorAll('input, select')];
        const invalid = required.find((input) => !input.checkValidity());
        if (invalid) {
          invalid.reportValidity();
          invalid.focus();
          return false;
        }
        return true;
      }

      showStep(index) {
        this.steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== index; });
        this.currentStep = index;
        this.progress.style.width = `${((index + 1) / this.steps.length) * 100}%`;
        this.steps[index].querySelector('legend')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      next() {
        if (this.validateStep() && this.currentStep < this.steps.length - 1) this.showStep(this.currentStep + 1);
      }

      back() {
        if (this.currentStep > 0) this.showStep(this.currentStep - 1);
      }

      updateCauseTotal() {
        const total = [...this.querySelectorAll('.nx-cause input')].reduce((sum, input) => sum + (Number(input.value) || 0), 0);
        const output = this.querySelector('[data-cause-total]');
        output.textContent = `${total}%`;
        output.parentElement.classList.toggle('is-invalid', total !== 100);
        return total;
      }

      calculate() {
        const error = this.querySelector('[data-error]');
        const invalid = [...this.form.querySelectorAll('input, select')].find((input) => !input.checkValidity());
        if (invalid) {
          this.showStep(this.steps.indexOf(invalid.closest('.nx-step')));
          invalid.reportValidity();
          invalid.focus();
          return;
        }
        if (this.number('weekly_sales') <= 0 || this.number('quantity_prepared') <= 0 || this.number('quantity_discarded') > this.number('quantity_prepared')) {
          error.textContent = 'Weekly sales and prepared quantity must be greater than zero. Discarded quantity cannot exceed prepared quantity.';
          error.hidden = false;
          return;
        }
        if (this.updateCauseTotal() !== 100) {
          error.textContent = 'Waste causes must total 100% before calculating.';
          error.hidden = false;
          return;
        }
        error.hidden = true;

        const weeklySales = this.number('weekly_sales');
        const prepared = this.number('quantity_prepared');
        const discarded = this.number('quantity_discarded');
        const unitCost = this.number('unit_cost');
        const unitPrice = this.number('unit_price');
        const laborCost = this.number('labor_hours') * this.number('labor_rate');
        const directProductCost = discarded * unitCost;
        const weeklyCost = Math.max(0, directProductCost + laborCost + this.number('disposal_cost') - this.number('markdown_recovery'));
        const annualCost = weeklyCost * 52;
        const wasteRate = prepared > 0 ? (discarded / prepared) * 100 : 0;
        const salesRatio = weeklySales > 0 ? (weeklyCost / weeklySales) * 100 : 0;
        const retailRisk = discarded * unitPrice * 52;
        const target = this.number('reduction_target');
        const potentialRecovery = annualCost * (target / 100);

        const causes = [
          { name: 'Overproduction', value: this.number('cause_overproduction'), recommendation: 'Start with daypart forecasting, smaller batch sizes and clear production triggers tied to actual demand.' },
          { name: 'Expiration and rotation', value: this.number('cause_expiration'), recommendation: 'Prioritize FEFO rotation, daily date reviews and earlier markdown or donation decision windows.' },
          { name: 'Preparation and portioning', value: this.number('cause_preparation'), recommendation: 'Standardize recipes, measure yields and reinforce portion and preparation controls through focused training.' },
          { name: 'Quality and holding time', value: this.number('cause_holding'), recommendation: 'Review holding-time compliance, batch frequency and replenishment practices by daypart.' },
          { name: 'Forecasting variance', value: this.number('cause_forecasting'), recommendation: 'Connect production plans to historical sales, promotions, weather, events and daypart patterns.' },
          { name: 'Unrecorded or unknown causes', value: this.number('cause_unknown'), recommendation: 'Introduce required waste-reason codes and a brief daily management review before targeting individual processes.' }
        ];
        causes.sort((a, b) => b.value - a.value);
        const leading = causes[0];
        const dataVisibility = Math.max(0, Math.min(100, 100 - this.number('cause_unknown')));

        this.querySelector('[data-weekly-cost]').textContent = this.currency.format(weeklyCost);
        this.querySelector('[data-annual-cost]').textContent = this.currency.format(annualCost);
        this.querySelector('[data-waste-rate]').textContent = `${this.percent.format(wasteRate)}%`;
        this.querySelector('[data-sales-ratio]').textContent = `${this.percent.format(salesRatio)}%`;
        this.querySelector('[data-retail-risk]').textContent = this.currency.format(retailRisk);
        this.querySelector('[data-recovery]').textContent = this.currency.format(potentialRecovery);
        this.querySelector('[data-leading-cause]').textContent = leading.name;
        this.querySelector('[data-recommendation]').textContent = leading.recommendation;
        const trainingMatch = leading.name === 'Preparation and portioning' || leading.name === 'Quality and holding time';
        const serviceLink = this.querySelector('[data-service-link]');
        serviceLink.href = trainingMatch ? '/products/team-training-process-adoption-session' : '/products/business-workflow-essentials-review';
        serviceLink.textContent = trainingMatch ? 'Explore Team Training & Process Adoption Session' : 'Explore Business Workflow Essentials Review';
        serviceLink.hidden = false;
        this.querySelector('[data-service-scope]').textContent = trainingMatch ? 'A remote training session for one agreed process. This is not a food-safety certification or a guarantee of waste reduction.' : 'A diagnostic review of one recurring workflow, with a workflow map and prioritized action plan. Implementation and guaranteed savings are not included.';
        this.querySelector('[data-score]').textContent = Math.round(dataVisibility);
        this.querySelector('[data-score-ring]').style.setProperty('--score-angle', `${dataVisibility * 3.6}deg`);

        const summary = this.querySelector('[data-result-summary]');
        if (summary) {
          summary.value = `Deli Waste Calculator Results\nWeekly waste cost: ${this.currency.format(weeklyCost)}\nAnnual waste cost: ${this.currency.format(annualCost)}\nWaste rate: ${this.percent.format(wasteRate)}%\nWaste-to-sales ratio: ${this.percent.format(salesRatio)}%\nAnnual retail value at risk: ${this.currency.format(retailRisk)}\nPotential recovery at ${target}% reduction: ${this.currency.format(potentialRecovery)}\nLeading cause: ${leading.name}\nRecommended direction: ${leading.recommendation}`;
        }

        this.form.hidden = true;
        this.results.hidden = false;
        this.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      restart() {
        this.results.hidden = true;
        this.form.hidden = false;
        this.showStep(0);
      }
    }
    customElements.define('nexiluma-waste-calculator', NexilumaWasteCalculator);
  }

  } catch(e) { console.error(e); }
})();
})();
